import { ItemList } from '../../orm'

class AdminDashboardList extends ItemList {
    getEntityKey() {
        return 'admin/dashboard'
    }
}

export const adminDashboardList = new AdminDashboardList('admin/dashboard')
